import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import ViewUI from 'view-design';
import ElementUI from 'element-ui';
import http from './request';
// pdf
import htmlToPdf from '@/utils/htmlToPdf';

import '@/common/viewerConfig';
import 'element-ui/lib/theme-chalk/index.css';
import '@/theme/elementIndex.scss';
import '@/theme/index.less';
import '@/assets/css/reset.css';
import '@/assets/css/resetIview.css';
import '@/assets/css/common.css';
import '@/assets/iconfont/iconfont.css';

import ChooseColumns from '@c/ChooseColumns/index.js';
import auth from './directive/auth';

import TablePoptip from '@c/Base/TablePoptip.vue';

// 使用 Vue.use() 方法就会调用工具方法中的install方法

// // 全局过滤器
import * as filters from './utils/filters';

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

import * as htWebPoints from './assets/js/ht-web-points';

// if (htWebPoints && process.env.VUE_APP_SENDSDK_URL && process.env.NODE_ENV !== 'development') {
//   htWebPoints.init({
//     appId: 'basic430hon',
//     name: '宏兔兔课后托管',
//     router,
//     config: {
//       userIdKey: 'userId',
//       tokenKey: 'loginToken'
//     },
//     sendUrl: process.env.VUE_APP_SENDSDK_URL
//   });
// }
Vue.use(htmlToPdf);
Vue.use(ViewUI);
Vue.use(ElementUI);
Vue.use(ChooseColumns);
Vue.use(auth);
Vue.component(TablePoptip.name, TablePoptip);

Vue.prototype.$http = http;
Vue.prototype.$eventHub = new Vue({});
Vue.prototype.$bus = new Vue();
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
